module.exports = __webpack_public_path__ + "static/img/erweima.2b920964.png";